import React from "react";
import {
  GET_FILTER_QUERY,
  GET_SELECT_GRID_COLUMN_XML,
  INSERT_FILTER_QUERY,
  UPDATE_FILTER_QUERY,
} from "src/api-setup/api-endpoints";
import { errStatusHandler, generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { setNewMessage } from "src/redux/actions/setting-actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { GridColumnDataMapper } from "src/utils/utils";
import { getUserCredential } from "src/lib/cookies";
import { EXPAND_ACTION_FILTER_QUERY_OBJECT } from "src/constants/constants";
import { GetAllSelectOperators } from "src/lib/common-service";

export default function FilterQuery() {
  const cookiesData = getUserCredential();
  const dispatch = useDispatch();
  const history = useHistory();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const [data, setData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);
  const [initialLoading, setLoadingState] = React.useState(false);
  const [isAPICalling, setAPICallingState] = React.useState(false);
  const [originalData, setOriginalData] = React.useState([]);
  const [noDataFound, setNoDataFound] = React.useState(false);

  const GetFilterQUery = (listData, isSort) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_FILTER_QUERY, null, header, listData, dispatch).then((res) => {
        if (res) {
          if (res.data.out_parameters.out_ret_code > 0) {
            setLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          setLoadingState(true);
          setAPICallingState(false);

          const columData = GridColumnDataMapper(res.data.out_parameters.out_column_xml);
          columData.forEach((item) => {
            item.show =
              item.field === "favorite_date" ||
              item.field === "action" ||
              item.field === "is_favorite" ||
              item.field === "filter_text"
                ? false
                : true;
          });
          columData.unshift(EXPAND_ACTION_FILTER_QUERY_OBJECT);
          setColumns(columData);

          res.data.row_result.map((item, idx) => {
            item.rowId = idx;
            return 0;
          });
          let newArray = [];
          if (isSort) {
            newArray = res.data.row_result;
          } else {
            newArray = res.data.row_result.sort((a, b) => b.is_favorite - a.is_favorite);
          }

          setData(newArray);
          setDataCount(res.data.out_parameters.out_total_rows);
          setOriginalData(newArray);
          setNoDataFound(false);
          resolve(newArray);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const GetFilterQUeryList = (listData, dispatch, history) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_FILTER_QUERY, null, header, listData, dispatch).then((res) => {
        if (res) {
          if (res.data.out_parameters.out_ret_code > 0) {
            setLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          setLoadingState(true);
          setAPICallingState(false);
          resolve(res.data.row_result);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const SaveFilterQuery = async (bodyData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, INSERT_FILTER_QUERY, null, generateHeader(), bodyData, dispatch).then((res) => {
        if (res.data.out_parameters.out_ret_code === 0) {
          let obj = {
            out_last_insert_key: res.data.out_parameters.out_last_insert_key,
            success: true,
          };
          resolve(obj);
        } else {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          let obj = {
            out_last_insert_key: "",
            success: false,
          };
          resolve(obj);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const UpdateFilterQuery = async (bodyData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, UPDATE_FILTER_QUERY, null, generateHeader(), bodyData, dispatch).then((res) => {
        if (res.data.out_parameters.out_ret_code === 0) {
          resolve(res.data.out_parameters);
        } else {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve(false);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const getColumList = (eventId, filterTableName) => {
    const reqData = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: null,
      in_filter_db_name: "procare_system",
      in_filter_table_name: filterTableName,
      in_result_name_mstr_key: 0,
      in_event_type_mstr_key: eventId || "",
      in_hide_column: 0,
    };
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, generateHeader(), reqData, dispatch).then((res) => {
        const { out_columns_xml } = res.data.out_parameters || {};
        if (res.data.out_parameters.out_ret_code === 0) {
          let columnData = GridColumnDataMapper(out_columns_xml) || [];
          resolve(columnData);
        } else {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve(false);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const fetchOperators = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await GetAllSelectOperators(null, dispatch);
        if (response) {
          resolve(response);
        } else {
          reject("No response received");
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  return [
    {
      data,
      originalData,
      noDataFound,
      dataCount,
      columns,
      initialLoading,
      isAPICalling,
      setData,
      setAPICallingState,
      setColumns,
      setLoadingState,
      setDataCount,
      setNoDataFound,
    },
    {
      SaveFilterQuery,
      GetFilterQUery,
      UpdateFilterQuery,
      GetFilterQUeryList,
      getColumList,
      fetchOperators,
    },
  ];
}
